module.exports = __webpack_public_path__ + "img/geo-zones.e0ab9eae.svg";